<div class="item-container w-100">
  <div
    *ngIf="!isEditing"
    [ngxTippy]="
      clickable == 'single'
        ? 'Click To ' + actionLabel
        : clickable == 'double'
        ? 'Double Click To ' + actionLabel
        : null
    "
    (click)="onClick()"
    [class.item-display]="clickable == 'single'"
    class="text-start"
    style="width: fit-content;"
  >
    <span class="item-name">{{ itemName || placeholder }}</span>
  </div>
  <div *ngIf="isEditing" class="rename-form">
    <input
    *ngIf="!multiLines"
      type="text"
      autofocus
      [(ngModel)]="itemName"
      (blur)="saveName(itemName)"
      (keydown.enter)="saveName(itemName)"
      class="item-name-input form-control form-control-flush p-0 bg-transparent border-0"
    />


    <textarea
    *ngIf="multiLines"
    autofocus
    [(ngModel)]="itemName"
    (blur)="saveName(itemName)"
    (keydown.enter)="saveName(itemName)"
    class="item-name-input form-control form-control-flush p-0 bg-transparent border-0 w-100"
  
    ></textarea>
  </div>
</div>
